import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_FILTER_PARAMS = { mode: 'dateMode', from: 'dateFrom', to: 'dateTo' };

export const readDateFilterParams = (params) => {
  const mode = params.get(DATE_FILTER_PARAMS.mode);
  const from = params.get(DATE_FILTER_PARAMS.from);
  const to = params.get(DATE_FILTER_PARAMS.to);
  if (!mode || !from || !to) return null;
  return { mode, from, to };
};

const buildDateFilter = ({ mode, from, to } = {}) => {
  if (!mode || !from || !to) return [];

  const fromDate = moment(from, DATE_FORMAT, true);
  const toDate = moment(to, DATE_FORMAT, true);
  if (!fromDate.isValid() || !toDate.isValid()) return [];

  const fromStart = fromDate.startOf('day').toISOString();
  const toEnd = toDate.endOf('day').toISOString();

  switch (mode) {
    case 'start':
      return [{ startDate_gte: fromStart }, { startDate_lte: toEnd }];
    case 'end':
      return [{ endDate_gte: fromStart }, { endDate_lte: toEnd }];
    case 'active':
      return [{ startDate_lte: toEnd }, { endDate_gte: fromStart }];
    default:
      return [];
  }
};

export default buildDateFilter;
